export default "__VITE_ASSET__Ds2lY5QG__"